module.exports = __webpack_public_path__ + "img/SANTANDER_Likeu.8649e5f9.png";